import * as React from "react";

function SvgUserpilot(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.9 25"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M6.3 0h13.3c3.5 0 6.3 2.8 6.3 6.3v12.4c0 3.5-2.8 6.3-6.3 6.3H6.3C2.8 25 0 22.2 0 18.7V6.3C0 2.8 2.8 0 6.3 0z"
        fill="#eb5a80"
      />
      <path
        d="M6.4 20.6c-.6-.7-1-1.7-.9-2.7 0-.8.1-1.5.3-2.3l1.3-6.1c0-.1.1-.4.2-.9s.2-1.1.2-1.7c0-.3-.1-.5-.2-.8-.1-.1-.4-.2-.6-.2-.6 0-1.1.3-1.5.6-.7.5-1.3 1.1-1.8 1.8-.1.3-.4.4-.6.5-.2 0-.4-.1-.5-.3-.2-.2-.3-.4-.3-.6 0-.6.2-1.1.6-1.5 1.1-1.8 3-2.9 5.1-3 .7 0 1.5.3 2 .8.5.7.8 1.5.7 2.3 0 .7 0 1.3-.1 2-.1.6-.3 1.4-.5 2.5L9 14.9l-.1.7c-.1.3-.1.6-.2.9 0 .3-.1.6-.1.9 0 .4.1.8.4 1.1.3.3.7.4 1.1.4 1-.1 2-.6 2.6-1.4 1.1-1.3 1.9-2.8 2.4-4.4.9-2.5 1.4-5.1 1.7-7.8 0-.5.2-1.1.4-1.5.3-.3.7-.5 1.1-.5.4 0 .8.1 1.1.4.3.4.4.9.4 1.5 0 .5-.1 1-.1 1.5-.1.6-.2 1.5-.4 2.6-.4 2.2-.7 4.2-.9 6-.1.6-.1 1.2-.2 1.8 0 .5.1 1 .4 1.3.3.3.7.5 1.1.5.5 0 1-.2 1.4-.5.6-.5 1.1-1 1.6-1.6.1-.2.4-.3.6-.3.2 0 .4.1.4.3.1.2.2.5.2.7 0 .5-.1 1-.4 1.3-.6.8-1.4 1.5-2.2 2-.7.4-1.5.6-2.3.6-1 .1-2-.3-2.7-.9-.6-.6-1-1.5-.9-2.4.1-1.1.2-2.1.3-3.2-.5 1.8-1.5 3.4-2.7 4.8-1 1.1-2.3 1.6-3.8 1.6-1.1.4-2 0-2.8-.7z"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgUserpilot);
